import { render, staticRenderFns } from "./userConfig.vue?vue&type=template&id=52d0ccea&scoped=true&"
import script from "./userConfig.vue?vue&type=script&lang=ts&"
export * from "./userConfig.vue?vue&type=script&lang=ts&"
import style0 from "./userConfig.vue?vue&type=style&index=0&id=52d0ccea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0ccea",
  null
  
)

export default component.exports